import { getBoolText, getTypedStepValues } from "features/contracting/helpers/contractingFormHelper";
import ContractingStepSummaryProps from "features/contracting/models/ContractingStepSummaryProps";
import OverviewStep from "features/contracting/models/steps/overview/OverviewStep";
import PageCard from "features/shared/components/card/PageCard";
import CheckValueInfoItem from "features/shared/components/infoItem/CheckValueInfoItem";
import { useTranslationWithPrefix } from "features/shared/hooks/useTranslationWithPrefix";
import _ from "lodash";
import React from "react";
import { useTranslation } from "react-i18next";

const OverviewSummary = ({
  contracting,
  step,
  configuration,
}: ContractingStepSummaryProps) => {
  // translations
  const tBool = useTranslation("shared\\enums\\boolEnum").t;
  const tLabels = useTranslationWithPrefix("contracting\\contracting", "overviewSummary");

  // private props
  const values = getTypedStepValues<OverviewStep>(contracting, step.component);

  // sub-renders
  const renderConsents = () => { 
    return configuration.consents?.map((consent, index) =>
      <CheckValueInfoItem
        title={consent.name!}
        value={values.consents?.[consent.code!]}
        formatValue={(x) => getBoolText(x, tBool)}
        isEmpty={_.isUndefined}
        key={index}
      />
    );
  }

  // render
  return (
    <PageCard
        title={tLabels("cardTitle")}
        bodyClassName="px-4 py-3"
      >
        {renderConsents()}
    </PageCard>
  );
};

export default OverviewSummary;
